import { createRouter, createWebHistory } from "vue-router"

import { useSessionStore } from "@/stores/userSession.js"

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior() {
    return { left: 0, top: 0 }
  },
  routes: [
    { path: "/login", name: "login", component: () => import("@/pages/Login.vue") },
    { path: "/licenses-list", name: "licensesList", component: () => import("@/pages/LicencesList.vue") },
    { path: "/customers", name: "customers", component: () => import("@/pages/Customers.vue") },
    { path: "/software", name: "software", component: () => import("@/pages/Software.vue") },
    // The tab is a route param so a panel can be linked to directly and survives a reload.
    { path: "/admin-panel/:tab?", name: "adminPanel", component: () => import("@/pages/AdminPanel.vue") },
    { path: "/", redirect: "/customers" },
    { path: "/:pathMatch(.*)*", redirect: "/login" }
  ]
})

router.beforeEach((to) => {
  const sessionStore = useSessionStore()
  if (!sessionStore.isLogged && to.name !== "login") {
    return { name: "login" }
  }
  return true
})

export default router
